import { apiClient } from "../client";
const ENDPOINTS = {
    DEPOSITS: "/deposits",
};
export const depositService = {
    getDeposit: () => apiClient.get(ENDPOINTS.DEPOSITS),
    createDeposit: (amount, updatedBy) => apiClient.post(ENDPOINTS.DEPOSITS, {
        amount,
        updatedBy,
    }),
};
